import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { BasePopup, Button, Icon, Label } from '@atlas/ui';

const TerminalBasePopup = ({
  buttonLabel,
  children,
  className,
  icon,
  onButtonClick,
  onClose,
  onSecondaryButtonClick,
  secondaryButtonLabel,
  text,
  title,
}) => {
  const popupClassName = cx('terminal-popup', className);

  return (
    <BasePopup className={popupClassName}>
      {onClose && (
        <button className="close-button" onClick={onClose} type="button">
          <Icon name="close" />
        </button>
      )}
      <div className="popup__content">
        {icon && <Icon height={44} name={icon} width={44} />}
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />
        {children}
      </div>
      <div className="popup__footer">
        <div className="popup__buttons">
          {secondaryButtonLabel && (
            <Button
              block
              label={secondaryButtonLabel}
              onClick={onSecondaryButtonClick}
              size="huge"
              type="secondary"
            />
          )}
          <Button block label={buttonLabel} onClick={onButtonClick} size="huge" type="primary" />
        </div>
      </div>
    </BasePopup>
  );
};

TerminalBasePopup.propTypes = {
  buttonLabel: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.string,
  onButtonClick: PropTypes.func,
  onClose: PropTypes.func,
  onSecondaryButtonClick: PropTypes.func,
  secondaryButtonLabel: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
};

export default TerminalBasePopup;
